// Referências externas
import React, { useEffect, useState, useRef } from 'react';
import { FiX, FiAlertTriangle, FiMinusCircle,FiPlusCircle } from 'react-icons/fi';

// Referências internas
import { DynamicLoading } from '../../../common';

// Estilo
import './styles.css';

import ModalConfirmacaoExclusao from "../ModalConfirmacaoExclusao/ModalConfirmacaoExclusao";

const permissaoUsuario = require('../../../services/permissaoUsuario');

export default function (props) {
    const mounted = useRef(false);
    const [token, setToken] = useState({});

    const [errosForm, setErrosForm] = useState({});

    const formInicial = {
        id_colaborador_acidentado: '',
        id_usuario_responsavel_registro: '',
        id_colaborador_supervisor_acidente: '',
        data_hora_acidente: '',
        local_acidente_resumido: '',
        vinculo_colaborador_acidente: '',
        setor_colaborador_acidente: '',
        funcao_colaborador_acidente: '',
        meses_colaborador_funcao_acidente: '',
        testemunha_acidente: '',
        descricao_local_acidente: '',
        endereco_local_acidente: '',
        apenas_pimeiros_socorros: '0',
        afastamento_ate_3: '0',
        afastamento_entre_4_e_30: '0',
        afastamento_maior_30: '0',
        obito: '0',
        choque_eletrico_baixa_tensao: '0',
        choque_eletrico_alta_tensao: '0',
        arco_eletrico: '0',
        explosao_painel_eletrico: '0',
        queda_mesma_altura: '0',
        queda_altura_elevada: '0',
        escorregao_ou_tropeco: '0',
        impacto_objeto_movel: '0',
        colisao_veiculo_ou_maquina: '0',
        prensamento: '0',
        corte_ou_laceracao: '0',
        perfuracao: '0',
        esmagamento: '0',
        entorse_ou_luxacao: '0',
        fratura: '0',
        queimadura_termica: '0',
        queimadura_quimica: '0',
        incendio_ou_principio: '0',
        inalacao: '0',
        contato_produto_quimico: '0',
        vazamento: '0',
        intoxicacao: '0',
        mordida_ou_picada: '0',
        alagamento_vendaval_deslizamento: '0',
        falha_equipamento_maquina: '0',
        falha_andaime_plataforma: '0',
        deficiencia_iluminacao: '0',
        violencia: '0',
        deslocamento: '0',
        outro_tipo_acidente: '',
        atendimento_medico: '',
        local_atendimento_medico: '',
        descricao_acidente: '',
        iluminacao_boa: '',
        clima: '',
        piso_seco: '',
        presenca_outros_riscos: '',
        outros_riscos: '',
        epi_presente: '',
        epi_ausente: '',
        epi_observacoes: 'Nenhuma',
        ato_inseguro_trabalhador: '0',
        desatencao_distracao: '0',
        pressa: '0',
        excesso_confianca: '0',
        falta_treinamento: '0',
        uso_inadequado_ferramentas: '0',
        improvisacao: '0',
        fadiga: '0',
        negligencia_procedimentos: '0',
        falha_equipamento: '0',
        falta_manutencao_preventiva: '0',
        equipamento_defeito_conhecido: '0',
        equipamento_inadequado: '0',
        ausencia_dispositivo_protecao: '0',
        projeto_inadequado: '0',
        iluminacao_inadequada: '0',
        ruido_excessivo: '0',
        temperatura_extrema: '0',
        piso_inseguro: '0',
        obstrucao_rotas: '0',
        sinalizacao_inadequada: '0',
        nao_uso_epi: '0',
        uso_incorreto_epi: '0',
        epi_danificado_ou_ineficaz: '0',
        falta_epi: '0',
        intrucao_inadeqada: '0',
        falta_planejamento: '0',
        mudanca_tarefa: '0',
        falha_comunicacao: '0',
        supervisao_ineficiente: '0',
        ausencia_procedimento: '0',
        interferencia_terceiros: '0',
        fatores_climaticos: '0',
        evento_externo_nao_previsto: '0',
        outra_causa_acidente: '0',
        descricao_outra_causa_acidente: '',
        numero_medidas_acidente: 0,
        acoes_corretivas_preventivas: '',
        observacoes_finais_licoes_aprendidas: '',
    }

    const [dadosForm, setDadosForm] = useState(formInicial);
    const [medidas, setMedidas] = useState([]);
    const [modalConfirmacaoExclusaoAberto, setModalConfirmacaoExclusaoAberto] = useState(false);

    function validarAcidente(e) {
        e.preventDefault();

        let verificacao_erros = {};

        if (dadosForm.id_colaborador_acidentado === '') { verificacao_erros.id_colaborador_acidentado = true }
        if (dadosForm.id_usuario_responsavel_registro === '') { verificacao_erros.id_usuario_responsavel_registro = true }
        if (dadosForm.id_colaborador_supervisor_acidente === '') { verificacao_erros.id_colaborador_supervisor_acidente = true }
        if (dadosForm.data_hora_acidente === '') { verificacao_erros.data_hora_acidente = true }
        if (dadosForm.local_acidente_resumido === '') { verificacao_erros.local_acidente_resumido = true }
        if (dadosForm.vinculo_colaborador_acidente === '') { verificacao_erros.vinculo_colaborador_acidente = true }
        if (dadosForm.setor_colaborador_acidente === '') { verificacao_erros.setor_colaborador_acidente = true }
        if (dadosForm.funcao_colaborador_acidente === '') { verificacao_erros.funcao_colaborador_acidente = true }
        if (dadosForm.meses_colaborador_funcao_acidente === '') { verificacao_erros.meses_colaborador_funcao_acidente = true }
        if (dadosForm.descricao_local_acidente === '') { verificacao_erros.descricao_local_acidente = true }
        if (dadosForm.endereco_local_acidente === '') { verificacao_erros.endereco_local_acidente = true }
        if (dadosForm.apenas_pimeiros_socorros !== '1' &&
            dadosForm.afastamento_ate_3 !== '1' &&
            dadosForm.afastamento_entre_4_e_30 !== '1' &&
            dadosForm.afastamento_maior_30 !== '1' &&
            dadosForm.obito !== '1') {
                verificacao_erros.grupo_1 = true
            }
        if (dadosForm.choque_eletrico_baixa_tensao !== '1' &&
            dadosForm.choque_eletrico_alta_tensao !== '1' &&
            dadosForm.arco_eletrico !== '1' &&
            dadosForm.explosao_painel_eletrico !== '1' &&
            dadosForm.queda_mesma_altura !== '1' &&
            dadosForm.queda_altura_elevada !== '1' &&
            dadosForm.escorregao_ou_tropeco !== '1' &&
            dadosForm.impacto_objeto_movel !== '1' &&
            dadosForm.colisao_veiculo_ou_maquina !== '1' &&
            dadosForm.prensamento !== '1' &&
            dadosForm.corte_ou_laceracao !== '1' &&
            dadosForm.perfuracao !== '1' &&
            dadosForm.esmagamento !== '1' &&
            dadosForm.entorse_ou_luxacao !== '1' &&
            dadosForm.fratura !== '1' &&
            dadosForm.queimadura_termica !== '1' &&
            dadosForm.queimadura_quimica !== '1' &&
            dadosForm.incendio_ou_principio !== '1' &&
            dadosForm.inalacao !== '1' &&
            dadosForm.contato_produto_quimico !== '1' &&
            dadosForm.vazamento !== '1' &&
            dadosForm.intoxicacao !== '1' &&
            dadosForm.mordida_ou_picada !== '1' &&
            dadosForm.alagamento_vendaval_deslizamento !== '1' &&
            dadosForm.falha_equipamento_maquina !== '1' &&
            dadosForm.falha_andaime_plataforma !== '1' &&
            dadosForm.deficiencia_iluminacao !== '1' &&
            dadosForm.violencia !== '1' &&
            dadosForm.deslocamento !== '1') {
                verificacao_erros.grupo_2 = true
            }
        if (dadosForm.atendimento_medico === "") { verificacao_erros.atendimento_medico = true }
        if (dadosForm.atendimento_medico === "1" && dadosForm.local_atendimento_medico === '') { verificacao_erros.local_atendimento_medico = true }
        if (dadosForm.atendimento_medico === "0" && dadosForm.local_atendimento_medico !== '') { verificacao_erros.local_atendimento_medico = true }
        if (dadosForm.descricao_acidente === '') { verificacao_erros.descricao_acidente = true }
        if (dadosForm.iluminacao_boa === '') { verificacao_erros.iluminacao_boa = true }
        if (dadosForm.clima === '') { verificacao_erros.clima = true }
        if (dadosForm.piso_seco === '') { verificacao_erros.piso_seco = true }
        if (dadosForm.presenca_outros_riscos === '') { verificacao_erros.presenca_outros_riscos = true }
        if (dadosForm.presenca_outros_riscos === "1" && dadosForm.outros_riscos === '') { verificacao_erros.outros_riscos = true }
        if (dadosForm.presenca_outros_riscos === "0" && dadosForm.outros_riscos !== '') { verificacao_erros.outros_riscos = true }
        if (dadosForm.epi_presente === '') { verificacao_erros.epi_presente = true }
        if (dadosForm.ato_inseguro_trabalhador !== '1' &&
            dadosForm.desatencao_distracao !== '1' &&
            dadosForm.pressa !== '1' &&
            dadosForm.excesso_confianca !== '1' &&
            dadosForm.falta_treinamento !== '1' &&
            dadosForm.uso_inadequado_ferramentas !== '1' &&
            dadosForm.improvisacao !== '1' &&
            dadosForm.fadiga !== '1' &&
            dadosForm.negligencia_procedimentos !== '1' &&
            dadosForm.falha_equipamento !== '1' &&
            dadosForm.falta_manutencao_preventiva !== '1' &&
            dadosForm.equipamento_defeito_conhecido !== '1' &&
            dadosForm.equipamento_inadequado !== '1' &&
            dadosForm.ausencia_dispositivo_protecao !== '1' &&
            dadosForm.projeto_inadequado !== '1' &&
            dadosForm.iluminacao_inadequada !== '1' &&
            dadosForm.ruido_excessivo !== '1' &&
            dadosForm.temperatura_extrema !== '1' &&
            dadosForm.piso_inseguro !== '1' &&
            dadosForm.obstrucao_rotas !== '1' &&
            dadosForm.sinalizacao_inadequada !== '1' &&
            dadosForm.nao_uso_epi !== '1' &&
            dadosForm.uso_incorreto_epi !== '1' &&
            dadosForm.epi_danificado_ou_ineficaz !== '1' &&
            dadosForm.falta_epi !== '1' &&
            dadosForm.intrucao_inadeqada !== '1' &&
            dadosForm.falta_planejamento !== '1' &&
            dadosForm.mudanca_tarefa !== '1' &&
            dadosForm.falha_comunicacao !== '1' &&
            dadosForm.supervisao_ineficiente !== '1' &&
            dadosForm.ausencia_procedimento !== '1' &&
            dadosForm.interferencia_terceiros !== '1' &&
            dadosForm.fatores_climaticos !== '1' &&
            dadosForm.evento_externo_nao_previsto !== '1') {
                verificacao_erros.grupo_3 = true
            }
        if (dadosForm.outra_causa_acidente === "") { verificacao_erros.outra_causa_acidente = true }
        if (dadosForm.outra_causa_acidente === "1" && dadosForm.descricao_outra_causa_acidente === '') { verificacao_erros.descricao_outra_causa_acidente = true }
        if (dadosForm.outra_causa_acidente === "0" && dadosForm.descricao_outra_causa_acidente !== '') { verificacao_erros.descricao_outra_causa_acidente = true }
        if (dadosForm.acoes_corretivas_preventivas === '') { verificacao_erros.acoes_corretivas_preventivas = true }
        if (dadosForm.observacoes_finais_licoes_aprendidas === '') { verificacao_erros.observacoes_finais_licoes_aprendidas = true }

        setErrosForm(verificacao_erros);

        return verificacao_erros;
    }
    
    function cadastrarAcidente(e) {
        e.preventDefault();

        const verificacao_erros = validarAcidente(e);

        if(Object.keys(verificacao_erros).length === 0) {
            props.cadastrarAcidente(dadosForm);
        }
    }

    function handleChange(e) {
        setDadosForm({
            ...dadosForm,
            [e.target.name]: e.target.value
        })
    }

    function diminuirNumeroMedidasAcidente(e) {
        e.preventDefault();
        if (dadosForm.numero_medidas_acidente > 0) {
            const ultima = medidas[medidas.length - 1];
            const preenchida = Object.values(ultima).some(valor => valor !== '');

            if (preenchida) {
                setModalConfirmacaoExclusaoAberto(true);
            } else {
                const novasMedidas = [...medidas];
                novasMedidas.pop();
                setMedidas(novasMedidas);

                setDadosForm({
                    ...dadosForm,
                    numero_medidas_acidente: dadosForm.numero_medidas_acidente - 1,
                    acoes_corretivas_preventivas: JSON.stringify(novasMedidas),
                })
            }
        }
    }
    
    function aumentaNumeroMedidasAcidente(e) {
        e.preventDefault();

        const novasMedidas = [...medidas, {
            acao: '',
            tipo: '',
            responsavel: '',
            prazo: '',
            status: ''
        }]

        setMedidas(novasMedidas);

        setDadosForm({
            ...dadosForm,
            numero_medidas_acidente: dadosForm.numero_medidas_acidente + 1,
            acoes_corretivas_preventivas: JSON.stringify(novasMedidas),
        })
    }

    function handleChangeMedida(index, campo, valor) {
        const atualizadas = [...medidas];
        atualizadas[index][campo] = valor;
        setMedidas(atualizadas);
        setDadosForm({
            ...dadosForm,
            acoes_corretivas_preventivas: JSON.stringify(atualizadas),
        })
    }

    function confirmarRemocaoMedida() {
        const novasMedidas = [...medidas];
        novasMedidas.pop();
        setMedidas(novasMedidas);
        setDadosForm({
            ...dadosForm,
            numero_medidas_acidente: dadosForm.numero_medidas_acidente - 1,
            acoes_corretivas_preventivas: JSON.stringify(novasMedidas),
        })
        setModalConfirmacaoExclusaoAberto(false);
    }

    function limparFormulario (e) {
        e.preventDefault();
        localStorage.removeItem('registroAcidente');
        setDadosForm(formInicial)
        setMedidas([]);
    }

    function preencherTeste(e) {
        e.preventDefault();

        const novasMedidas = [...medidas, {
            acao: 'Ação Teste',
            tipo: 'Corretiva',
            responsavel: 'Responsável Corretiva',
            prazo: '',
            status: 'Concluído'
        }, {
            acao: 'Ação Teste 2',
            tipo: 'Preventiva',
            responsavel: 'Responsável Preventiva',
            prazo: '',
            status: 'Em andamento'
        }]
        setMedidas(novasMedidas);

        setDadosForm({
            id_colaborador_acidentado: 3,
            id_usuario_responsavel_registro: 22,
            id_colaborador_supervisor_acidente: 1,
            data_hora_acidente: '2024-07-04 15:41:00',
            local_acidente_resumido: 'Local Teste',
            vinculo_colaborador_acidente: 'CLT',
            setor_colaborador_acidente: 'Setor Teste',
            funcao_colaborador_acidente: 'Função Teste',
            meses_colaborador_funcao_acidente: '11',
            testemunha_acidente: 'Testemunha teste',
            descricao_local_acidente: 'Descrição Local Teste',
            endereco_local_acidente: 'Endereço Local Teste',
            apenas_pimeiros_socorros: '',
            afastamento_ate_3: '',
            afastamento_entre_4_e_30: '1',
            afastamento_maior_30: '',
            obito: '',
            choque_eletrico_baixa_tensao: '1',
            choque_eletrico_alta_tensao: '',
            arco_eletrico: '',
            explosao_painel_eletrico: '',
            queda_mesma_altura: '1',
            queda_altura_elevada: '',
            escorregao_ou_tropeco: '',
            impacto_objeto_movel: '',
            colisao_veiculo_ou_maquina: '',
            prensamento: '',
            corte_ou_laceracao: '1',
            perfuracao: '',
            esmagamento: '',
            entorse_ou_luxacao: '',
            fratura: '',
            queimadura_termica: '',
            queimadura_quimica: '',
            incendio_ou_principio: '',
            inalacao: '',
            contato_produto_quimico: '',
            vazamento: '',
            intoxicacao: '',
            mordida_ou_picada: '',
            alagamento_vendaval_deslizamento: '',
            falha_equipamento_maquina: '',
            falha_andaime_plataforma: '',
            deficiencia_iluminacao: '1',
            violencia: '',
            deslocamento: '',
            outro_tipo_acidente: '',
            atendimento_medico: '1',
            local_atendimento_medico: 'UPA Teste',
            descricao_acidente: `
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed bibendum augue sit amet est cursus dictum. Nunc tincidunt dolor justo, at euismod nunc sollicitudin id. Ut pharetra porttitor congue. Maecenas at metus in ipsum iaculis viverra nec nec sem. Integer semper lorem eget interdum pellentesque. Nulla elementum ornare nibh, egestas malesuada felis auctor ac. Sed pharetra gravida euismod. Praesent commodo nulla vitae felis tempus tristique. In risus magna, semper sed felis at, elementum ornare neque. Vivamus condimentum tellus quis ipsum sollicitudin dictum.
                Cras facilisis a eros id molestie. Maecenas nec magna sem. Suspendisse potenti. Ut in blandit nunc, vitae facilisis nunc. Sed non eros eget urna vehicula mattis non eget sapien. Donec porttitor lectus non ante rutrum vehicula. Ut blandit, eros a malesuada rhoncus, orci est pretium lectus, vel dictum orci sapien ac neque. Interdum et malesuada fames ac ante ipsum primis in faucibus.
                Morbi id nunc rhoncus, malesuada nisl id, vestibulum leo. Curabitur magna dui, fringilla nec mauris nec, sodales dignissim tortor. Curabitur eu libero at turpis condimentum egestas. Pellentesque id rutrum lacus. Proin quis diam urna. Sed dolor turpis, volutpat vitae convallis vel, aliquam id nibh. Aenean viverra massa quis metus tincidunt vestibulum. Aliquam a lectus et orci efficitur sodales sit amet sed orci. Praesent a augue nibh. Donec felis nulla, luctus nec magna eu, consequat efficitur purus. Phasellus sit amet magna dolor. Phasellus ornare ornare nisi, a tincidunt sem finibus quis. Duis sollicitudin massa sed nisl gravida lacinia eget dignissim risus. Nam eget sapien lectus. Donec vel arcu sit amet quam dapibus mattis. Suspendisse placerat ligula nunc.
            `, 
            iluminacao_boa: '0',
            clima: 'Sol',
            piso_seco: '1',
            presenca_outros_riscos: '0',
            outros_riscos: '',
            epi_presente: 'Luva',
            epi_ausente: 'Óculos',
            epi_observacoes: 'EPIs foram entregues',
            ato_inseguro_trabalhador: '1',
            desatencao_distracao: '',
            pressa: '1',
            excesso_confianca: '1',
            falta_treinamento: '',
            uso_inadequado_ferramentas: '',
            improvisacao: '1',
            fadiga: '',
            negligencia_procedimentos: '1',
            falha_equipamento: '',
            falta_manutencao_preventiva: '',
            equipamento_defeito_conhecido: '',
            equipamento_inadequado: '',
            ausencia_dispositivo_protecao: '',
            projeto_inadequado: '',
            iluminacao_inadequada: '1',
            ruido_excessivo: '',
            temperatura_extrema: '',
            piso_inseguro: '',
            obstrucao_rotas: '',
            sinalizacao_inadequada: '',
            nao_uso_epi: '1',
            uso_incorreto_epi: '',
            epi_danificado_ou_ineficaz: '',
            falta_epi: '',
            intrucao_inadeqada: '',
            falta_planejamento: '',
            mudanca_tarefa: '1',
            falha_comunicacao: '',
            supervisao_ineficiente: '',
            ausencia_procedimento: '',
            interferencia_terceiros: '1',
            fatores_climaticos: '',
            evento_externo_nao_previsto: '',
            outra_causa_acidente: '0',
            descricao_outra_causa_acidente: '',
            numero_medidas_acidente: 2,
            acoes_corretivas_preventivas: JSON.stringify(novasMedidas),
            observacoes_finais_licoes_aprendidas: `
                Phasellus id velit tincidunt, lacinia urna eget, placerat neque. Integer dignissim suscipit dui, quis lacinia libero. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Cras sit amet ante elit. Nullam nisi ex, accumsan quis sapien vitae, dignissim feugiat felis. Suspendisse sollicitudin id sem eu malesuada. Curabitur maximus leo eu nisl imperdiet accumsan. Proin tempus aliquet efficitur. In venenatis euismod auctor. Pellentesque eu lacus nec ligula bibendum tempus. Nunc eros massa, viverra nec dolor ut, feugiat euismod lacus. Aliquam id rhoncus odio, id elementum est.
            `,
        })
    }

    useEffect(() => {
        if (!mounted.current) {
            // Carrega token do usuário
            setToken(JSON.parse(localStorage.getItem('sgc_br')));

            // Carrega rascunho salvo, se houver
            const dadosSalvos = localStorage.getItem('registroAcidente');
            if (dadosSalvos) {
                const dadosFormRecuperado = JSON.parse(dadosSalvos);
                setDadosForm(dadosFormRecuperado);

                if (dadosFormRecuperado.acoes_corretivas_preventivas.length > 0) {
                    setMedidas(JSON.parse(dadosFormRecuperado.acoes_corretivas_preventivas));
                }
            }

            mounted.current = true;
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('registroAcidente', JSON.stringify(dadosForm));

    }, [dadosForm]);

    useEffect(() => {
        if (props.formCadastrarAcidenteFoiEnviado) {
            localStorage.removeItem('registroAcidente');
            setDadosForm(formInicial)
            setMedidas([]);
        }
    }, [props.formCadastrarAcidenteFoiEnviado]);

    return (
        <div className="modal-fundo">
            
            { (modalConfirmacaoExclusaoAberto) &&
                <ModalConfirmacaoExclusao
                    confirmarRemocaoMedida={confirmarRemocaoMedida}
                    fecharModal={() => setModalConfirmacaoExclusaoAberto(false)}
            /> }

            <div className="modal-form-dados-acidente">
                <div className="modal-conteudo2">
                    <div className="modal-header">
                        <h2 className="wrapper-titulo">Registrar Acidente</h2>
                            <button className="botao-fechar-modal" onClick={() => props.fecharModal()} >
                            <FiX />
                        </button>
                    </div>
                    <div >
                        <form className="modal-hseq">
                            <h3>CABEÇALHO</h3>
                            <div className="modal-hseq-bloco1">
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="id_usuario_responsavel_registro" className="label-client-text">
                                        Responsável pelo preenchimento {errosForm.id_usuario_responsavel_registro && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <select
                                        name="id_usuario_responsavel_registro"
                                        className="importar-select"
                                        onChange={e => { handleChange(e); }}
                                        value={dadosForm.id_usuario_responsavel_registro}
                                        style={{width: "190px"}}
                                    >
                                        <option value="">Selecione</option>

                                        {props.listaUsuariosCorrespondentes
                                        .filter(x => !x.nome_usuario.toLowerCase().includes("revogado"))
                                        .map(x => (
                                            <option key={x.id_usuario} value={x.id_usuario}>{x.nome_usuario}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="id_colaborador_supervisor_acidente" className="label-client-text">
                                        Supervisor na ocasiação do acidente {errosForm.id_colaborador_supervisor_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <select
                                        name="id_colaborador_supervisor_acidente"
                                        className="importar-select"
                                        onChange={e => { handleChange(e); }}
                                        value={dadosForm.id_colaborador_supervisor_acidente}
                                        style={{width: "190px"}}
                                    >
                                        <option value="">Selecione</option>
                                        {props.listaColaborador
                                            .filter(x => x.nome_colaborador !== "Nenhum")
                                            .map(x => (
                                                <option key={x.id_colaborador} value={x.id_colaborador}>{x.nome_completo_colaborador}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="data_hora_acidente" className="label-client-text">
                                        Data e Hora do Acidente {errosForm.data_hora_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        type="datetime-local"
                                        id="data_hora_acidente"
                                        name="data_hora_acidente"
                                        className="modal-cliente-input"
                                        value={dadosForm.data_hora_acidente}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-personalizado">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="local_acidente_resumido" className="label-client-text">
                                        Local {errosForm.local_acidente_resumido && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="local_acidente_resumido"
                                        name="local_acidente_resumido"
                                        value={dadosForm.local_acidente_resumido}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>DADOS DA VÍTIMA</h3>
                            <div className="modal-hseq-bloco1">
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="id_colaborador_acidentado" className="label-client-text">
                                        Vítima {errosForm.id_colaborador_acidentado && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <select
                                        name="id_colaborador_acidentado"
                                        className="importar-select"
                                        onChange={e => { handleChange(e); }}
                                        value={dadosForm.id_colaborador_acidentado}
                                    >
                                        <option value="">Selecione</option>
                                        {props.listaColaborador
                                            .filter(x => x.nome_colaborador !== "Nenhum")
                                            .map(x => (
                                                <option key={x.id_colaborador} value={x.id_colaborador}>{x.nome_completo_colaborador}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="vinculo_colaborador_acidente" className="label-client-text">
                                        Tipo de vínculo {errosForm.vinculo_colaborador_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <select
                                        name="vinculo_colaborador_acidente"
                                        className="importar-select"
                                        onChange={e => { handleChange(e); }}
                                        value={dadosForm.vinculo_colaborador_acidente}
                                    >
                                        <option value="">Selecione</option>
                                        <option value="CLT">CLT</option>
                                        <option value="Terceirizado">Terceirizado</option>
                                        <option value="Estagiário">Estagiário</option>
                                        <option value="Sócio">Sócio</option>
                                    </select>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="setor_colaborador_acidente" className="label-client-text">
                                        Setor {errosForm.setor_colaborador_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="setor_colaborador_acidente"
                                        name="setor_colaborador_acidente"
                                        value={dadosForm.setor_colaborador_acidente}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="funcao_colaborador_acidente" className="label-client-text">
                                        Função na ocasião do acidente {errosForm.funcao_colaborador_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="funcao_colaborador_acidente"
                                        name="funcao_colaborador_acidente"
                                        value={dadosForm.funcao_colaborador_acidente}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>

                                <div className="input-group-margem-reduzida">
                                    <label style={{ whiteSpace: "nowrap" }} htmlFor="meses_colaborador_funcao_acidente" className="label-client-text">
                                        Tempo na função (meses) {errosForm.meses_colaborador_funcao_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="meses_colaborador_funcao_acidente"
                                        name="meses_colaborador_funcao_acidente"
                                        value={dadosForm.meses_colaborador_funcao_acidente}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>TESTEMUNHAS</h3>
                            <div className="modal-hseq-bloco1">
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="testemunha_acidente" className="label-client-text">
                                        Insira o nome de todas as testemunhas {errosForm.testemunha_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="testemunha_acidente"
                                        name="testemunha_acidente"
                                        value={dadosForm.testemunha_acidente}
                                        style={{width: "450px"}}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>LOCAL DO ACIDENTE</h3>
                            <div className="modal-hseq-bloco1">
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="descricao_local_acidente" className="label-client-text">
                                        Descrição {errosForm.descricao_local_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="descricao_local_acidente"
                                        name="descricao_local_acidente"
                                        value={dadosForm.descricao_local_acidente}
                                        style={{width: "300px"}}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="endereco_local_acidente" className="label-client-text">
                                        Endereço {errosForm.endereco_local_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="endereco_local_acidente"
                                        name="endereco_local_acidente"
                                        value={dadosForm.endereco_local_acidente}
                                        style={{width: "300px"}}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>CONSEQUÊNCIA DO ACIDENTE</h3>
                            <div className="modal-hseq-bloco1">
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="apenas_pimeiros_socorros"
                                            id="apenas_pimeiros_socorros"
                                            checked={dadosForm.apenas_pimeiros_socorros === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, apenas_pimeiros_socorros: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="apenas_pimeiros_socorros" className="label-client-radio">
                                            Apenas primeiros socorros {errosForm.grupo_1 && <FiAlertTriangle size={12} color="#ff0000"/>}
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="afastamento_ate_3"
                                            id="afastamento_ate_3"
                                            checked={dadosForm.afastamento_ate_3 === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, afastamento_ate_3: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="afastamento_ate_3" className="label-client-radio">
                                            Afastamento até 3 dias {errosForm.grupo_1 && <FiAlertTriangle size={12} color="#ff0000"/>}
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="afastamento_entre_4_e_30"
                                            id="afastamento_entre_4_e_30"
                                            checked={dadosForm.afastamento_entre_4_e_30 === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, afastamento_entre_4_e_30: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="afastamento_entre_4_e_30" className="label-client-radio">
                                            Afastamento entre 4 e 30 dias {errosForm.grupo_1 && <FiAlertTriangle size={12} color="#ff0000"/>}
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="afastamento_maior_30"
                                            id="afastamento_maior_30"
                                            checked={dadosForm.afastamento_maior_30 === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, afastamento_maior_30: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="afastamento_maior_30" className="label-client-radio">
                                            Afastamento maior que 30 dias {errosForm.grupo_1 && <FiAlertTriangle size={12} color="#ff0000"/>}
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="obito"
                                            id="obito"
                                            checked={dadosForm.obito === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, obito: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="obito" className="label-client-radio">
                                            Óbito {errosForm.grupo_1 && <FiAlertTriangle size={12} color="#ff0000"/>}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>TIPO DE ACIDENTE</h3> {errosForm.grupo_2 && <FiAlertTriangle size={12} color="#ff0000"/>}
                            <div className="modal-hseq-bloco1">
                                <h4 style={{height: "35px", lineHeight: "35px"}}>Risco elétrico:</h4>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="choque_eletrico_baixa_tensao"
                                            id="choque_eletrico_baixa_tensao"
                                            checked={dadosForm.choque_eletrico_baixa_tensao === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, choque_eletrico_baixa_tensao: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="choque_eletrico_baixa_tensao" className="label-client-radio">
                                            Choque elétrico (baixa tensão)
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="choque_eletrico_alta_tensao"
                                            id="choque_eletrico_alta_tensao"
                                            checked={dadosForm.choque_eletrico_alta_tensao === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, choque_eletrico_alta_tensao: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="choque_eletrico_alta_tensao" className="label-client-radio">
                                            Choque elétrico (alta tensão)
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="arco_eletrico"
                                            id="arco_eletrico"
                                            checked={dadosForm.arco_eletrico === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, arco_eletrico: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="arco_eletrico" className="label-client-radio">
                                            Arco elétrico
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="explosao_painel_eletrico"
                                            id="explosao_painel_eletrico"
                                            checked={dadosForm.explosao_painel_eletrico === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, explosao_painel_eletrico: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="explosao_painel_eletrico" className="label-client-radio">
                                            Explosão de painel elétrico
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-hseq-bloco1">
                                <h4 style={{height: "35px", lineHeight: "35px"}}>Risco Físico e Mecânico:</h4>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="queda_mesma_altura"
                                            id="queda_mesma_altura"
                                            checked={dadosForm.queda_mesma_altura === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, queda_mesma_altura: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="queda_mesma_altura" className="label-client-radio">
                                            Queda em mesma altura
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="queda_altura_elevada"
                                            id="queda_altura_elevada"
                                            checked={dadosForm.queda_altura_elevada === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, queda_altura_elevada: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="queda_altura_elevada" className="label-client-radio">
                                            Queda de altura (telhado, escada, estrutura metálica)
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="escorregao_ou_tropeco"
                                            id="escorregao_ou_tropeco"
                                            checked={dadosForm.escorregao_ou_tropeco === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, escorregao_ou_tropeco: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="escorregao_ou_tropeco" className="label-client-radio">
                                            Escorregão ou tropeço
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="impacto_objeto_movel"
                                            id="impacto_objeto_movel"
                                            checked={dadosForm.impacto_objeto_movel === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, impacto_objeto_movel: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="impacto_objeto_movel" className="label-client-radio">
                                            Impacto com objeto móvel
                                        </label>
                                    </div>
                                </div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="colisao_veiculo_ou_maquina"
                                            id="colisao_veiculo_ou_maquina"
                                            checked={dadosForm.colisao_veiculo_ou_maquina === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, colisao_veiculo_ou_maquina: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="colisao_veiculo_ou_maquina" className="label-client-radio">
                                            Colisão com veículo ou máquina
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="prensamento"
                                            id="prensamento"
                                            checked={dadosForm.prensamento === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, prensamento: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="prensamento" className="label-client-radio">
                                            Prensamento entre objetos
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="corte_ou_laceracao"
                                            id="corte_ou_laceracao"
                                            checked={dadosForm.corte_ou_laceracao === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, corte_ou_laceracao: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="corte_ou_laceracao" className="label-client-radio">
                                            Corte ou laceração (manual ou com ferramenta)
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="perfuracao"
                                            id="perfuracao"
                                            checked={dadosForm.perfuracao === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, perfuracao: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="perfuracao" className="label-client-radio">
                                            Perfuração ou perfuração por objeto pontiagudo
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="esmagamento"
                                            id="esmagamento"
                                            checked={dadosForm.esmagamento === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, esmagamento: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="esmagamento" className="label-client-radio">
                                            Esmagamento
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="entorse_ou_luxacao"
                                            id="entorse_ou_luxacao"
                                            checked={dadosForm.entorse_ou_luxacao === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, entorse_ou_luxacao: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="entorse_ou_luxacao" className="label-client-radio">
                                            Entorse ou luxação
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="fratura"
                                            id="fratura"
                                            checked={dadosForm.fratura === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, fratura: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="fratura" className="label-client-radio">
                                            Fratura
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-hseq-bloco1">
                            <h4 style={{height: "35px", lineHeight: "35px"}}>Incêndios e Queimaduras:</h4>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="queimadura_termica"
                                            id="queimadura_termica"
                                            checked={dadosForm.queimadura_termica === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, queimadura_termica: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="queimadura_termica" className="label-client-radio">
                                            Queimadura térmica (fogo, vapor, superfície quente)
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="queimadura_quimica"
                                            id="queimadura_quimica"
                                            checked={dadosForm.queimadura_quimica === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, queimadura_quimica: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="queimadura_quimica" className="label-client-radio">
                                            Queimadura química
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="incendio_ou_principio"
                                            id="incendio_ou_principio"
                                            checked={dadosForm.incendio_ou_principio === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, incendio_ou_principio: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="incendio_ou_principio" className="label-client-radio">
                                            Incêndio / Princípio de incêndio
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="inalacao"
                                            id="inalacao"
                                            checked={dadosForm.inalacao === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, inalacao: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="inalacao" className="label-client-radio">
                                            Inalação de fumaça ou gases tóxicos
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-hseq-bloco1">
                            <h4 style={{height: "35px", lineHeight: "35px"}}>Exposição a Substâncias Perigosas:</h4>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="contato_produto_quimico"
                                            id="contato_produto_quimico"
                                            checked={dadosForm.contato_produto_quimico === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, contato_produto_quimico: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="contato_produto_quimico" className="label-client-radio">
                                            Contato com produto químico
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="vazamento"
                                            id="vazamento"
                                            checked={dadosForm.vazamento === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, vazamento: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="vazamento" className="label-client-radio">
                                            Vazamento de gás ou fluido
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="intoxicacao"
                                            id="intoxicacao"
                                            checked={dadosForm.intoxicacao === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, intoxicacao: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="intoxicacao" className="label-client-radio">
                                            Intoxicação por substância
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-hseq-bloco1">
                            <h4 style={{height: "35px", lineHeight: "35px"}}>Fatores Ambientais / Naturais:</h4>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="mordida_ou_picada"
                                            id="mordida_ou_picada"
                                            checked={dadosForm.mordida_ou_picada === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, mordida_ou_picada: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="mordida_ou_picada" className="label-client-radio">
                                            Mordida ou picada (insetos, aranhas, cobras etc.)
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="alagamento_vendaval_deslizamento"
                                            id="alagamento_vendaval_deslizamento"
                                            checked={dadosForm.alagamento_vendaval_deslizamento === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, alagamento_vendaval_deslizamento: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="alagamento_vendaval_deslizamento" className="label-client-radio">
                                            Alagamento / vendaval / deslizamento
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-hseq-bloco1">
                            <h4 style={{height: "35px", lineHeight: "35px"}}>Outros Acidentes ou Situações:</h4>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="falha_equipamento_maquina"
                                            id="falha_equipamento_maquina"
                                            checked={dadosForm.falha_equipamento_maquina === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, falha_equipamento_maquina: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="falha_equipamento_maquina" className="label-client-radio">
                                            Falha de equipamento / ferramenta
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="falha_andaime_plataforma"
                                            id="falha_andaime_plataforma"
                                            checked={dadosForm.falha_andaime_plataforma === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, falha_andaime_plataforma: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="falha_andaime_plataforma" className="label-client-radio">
                                            Falha de andaime / plataforma
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="deficiencia_iluminacao"
                                            id="deficiencia_iluminacao"
                                            checked={dadosForm.deficiencia_iluminacao === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, deficiencia_iluminacao: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="deficiencia_iluminacao" className="label-client-radio">
                                            Deficiência de iluminação / visibilidade
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="violencia"
                                            id="violencia"
                                            checked={dadosForm.violencia === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, violencia: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="violencia" className="label-client-radio">
                                            Atos de violência
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <div className="modal-cliente-radio">
                                        <input
                                            type="checkbox"
                                            name="deslocamento"
                                            id="deslocamento"
                                            checked={dadosForm.deslocamento === '1'}
                                            value="1"
                                            onChange={e => setDadosForm({ ...dadosForm, deslocamento: e.target.checked ? '1' : '' })}
                                        />
                                        <label htmlFor="deslocamento" className="label-client-radio">
                                            Acidente em deslocamento (trajeto interno/externo)
                                        </label>
                                    </div>
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="outro_tipo_acidente" style={{ whiteSpace: "nowrap" }} className="label-client-text">
                                        Outro (especificar): {errosForm.outro_tipo_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="outro_tipo_acidente"
                                        name="outro_tipo_acidente"
                                        value={dadosForm.outro_tipo_acidente}
                                        style={{width: "300px"}}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>ATENDIMENTO MÉDICO</h3>
                            <div className="modal-hseq-bloco1">

                            <div className="input-group-margem-reduzida">
                                <label className="label-client-text" style={{ display: 'block' }}>
                                   Houve atendimento médico? {errosForm.atendimento_medico && <FiAlertTriangle size={12} color="#ff0000"/>}
                                </label>

                                <div className="modal-cliente-radio">
                                    <input
                                    type="radio"
                                    id="atendimento_medico_sim"
                                    name="atendimento_medico"
                                    value="1"
                                    checked={dadosForm.atendimento_medico === '1'}
                                    onChange={e => setDadosForm({ ...dadosForm, atendimento_medico: e.target.value })}
                                    />
                                    <label htmlFor="atendimento_medico_sim" className="label-client-radio">Sim</label>
                                </div>
                                
                                <div className="modal-form-dados-acidente-espaco"></div>

                                <div className="modal-cliente-radio">
                                    <input
                                    type="radio"
                                    id="atendimento_medico_nao"
                                    name="atendimento_medico"
                                    value="0"
                                    checked={dadosForm.atendimento_medico === '0'}
                                    onChange={e => setDadosForm({ ...dadosForm, atendimento_medico: e.target.value })}
                                    />
                                    <label htmlFor="atendimento_medico_nao" className="label-client-radio">Não</label>
                                </div>
                            </div>

                            <div className="modal-form-dados-acidente-espaco"></div>
                            
                            <div className="input-group-margem-reduzida">
                                <label htmlFor="local_atendimento_medico" className="label-client-text">
                                    Local: {errosForm.local_atendimento_medico && <FiAlertTriangle size={12} color="#ff0000"/>}
                                </label>
                                <input
                                    className="modal-cliente-input"
                                    type="text"
                                    id="local_atendimento_medico"
                                    name="local_atendimento_medico"
                                    value={dadosForm.local_atendimento_medico}
                                    style={{width: "300px"}}
                                    onChange={e => handleChange(e)}
                                />
                            </div>

                            </div>
                            <br /> <hr /> <br />
                            <h3>DESCRIÇÃO DO ACIDENTE</h3>
                            <div className="modal-hseq-bloco1">
                                <div className="input-group-margem-reduzida"> 
                                    <label htmlFor="descricao_acidente" className="label-client-text">
                                        Informe de forma detalhada o que ocorreu: {errosForm.descricao_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <textarea
                                        className="modal-cliente-input"
                                        id="descricao_acidente"
                                        name="descricao_acidente"
                                        value={dadosForm.descricao_acidente}
                                        onChange={e => handleChange(e)}
                                        rows="10"
                                        cols="300"
                                    />
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>CONDIÇÕES AMBIENTAIS NO MOMENTO</h3>
                            <div className="modal-hseq-bloco1">
                                <div className="input-group-margem-reduzida">
                                    <label className="label-client-text">
                                        Iluminação: {errosForm.iluminacao_boa && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <div className="modal-cliente-radio">
                                        <input
                                        type="radio"
                                        id="iluminacao_boa"
                                        name="iluminacao_boa"
                                        value="1"
                                        checked={dadosForm.iluminacao_boa === "1"}
                                        onChange={e => setDadosForm({ ...dadosForm, iluminacao_boa: e.target.value })}
                                        />
                                        <label htmlFor="iluminacao_boa" className="label-client-radio">Boa</label>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="modal-cliente-radio">
                                        <input
                                        type="radio"
                                        id="iluminacao_ruim"
                                        name="iluminacao_boa"
                                        value="0"
                                        checked={dadosForm.iluminacao_boa === "0"}
                                        onChange={e => setDadosForm({ ...dadosForm, iluminacao_boa: e.target.value })}
                                        />
                                        <label htmlFor="iluminacao_ruim" className="label-client-radio">Ruim</label>
                                    </div>
                                </div>

                                <div className="modal-form-dados-acidente-espaco"></div>

                                <div className="input-group-margem-reduzida">
                                    <label className="label-client-text">
                                        Clima: {errosForm.clima && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <div className="modal-cliente-radio">
                                        <input
                                        type="radio"
                                        id="clima_sol"
                                        name="clima"
                                        value="Sol"
                                        checked={dadosForm.clima === "Sol"}
                                        onChange={e => setDadosForm({ ...dadosForm, clima: e.target.value })}
                                        />
                                        <label htmlFor="clima_sol" className="label-client-radio">Sol</label>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="modal-cliente-radio">
                                        <input
                                        type="radio"
                                        id="clima_chuva"
                                        name="clima"
                                        value="Ruim"
                                        checked={dadosForm.clima === "Ruim"}
                                        onChange={e => setDadosForm({ ...dadosForm, clima: e.target.value })}
                                        />
                                        <label htmlFor="clima_chuva" className="label-client-radio">Ruim</label>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="modal-cliente-radio">
                                        <input
                                        type="radio"
                                        id="clima_nublado"
                                        name="clima"
                                        value="Nublado"
                                        checked={dadosForm.clima === "Nublado"}
                                        onChange={e => setDadosForm({ ...dadosForm, clima: e.target.value })}
                                        />
                                        <label htmlFor="clima_nublado" className="label-client-radio">Nublado</label>
                                    </div>
                                </div>

                                <div className="modal-form-dados-acidente-espaco"></div>

                                <div className="input-group-margem-reduzida">
                                    <label className="label-client-text">
                                        Piso: {errosForm.piso_seco && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <div className="modal-cliente-radio">
                                        <input
                                        type="radio"
                                        id="piso_seco"
                                        name="piso_seco"
                                        value="1"
                                        checked={dadosForm.piso_seco === "1"}
                                        onChange={e => setDadosForm({ ...dadosForm, piso_seco: e.target.value })}
                                        />
                                        <label htmlFor="piso_seco" className="label-client-radio">Seco</label>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="modal-cliente-radio">
                                        <input
                                        type="radio"
                                        id="piso_escorregadio"
                                        name="piso_seco"
                                        value="0"
                                        checked={dadosForm.piso_seco === "0"}
                                        onChange={e => setDadosForm({ ...dadosForm, piso_seco: e.target.value })}
                                        />
                                        <label htmlFor="piso_escorregadio" className="label-client-radio">Escorregadio</label>
                                    </div>
                                </div>

                                <div className="modal-form-dados-acidente-espaco"></div>

                                <div className="input-group-margem-reduzida">
                                    <label className="label-client-text">
                                        Presença de riscos próximos? {errosForm.presenca_outros_riscos && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <div className="modal-cliente-radio">
                                        <input
                                        type="radio"
                                        id="presenca_outros_riscos"
                                        name="presenca_outros_riscos"
                                        value="1"
                                        checked={dadosForm.presenca_outros_riscos === "1"}
                                        onChange={e => setDadosForm({ ...dadosForm, presenca_outros_riscos: e.target.value })}
                                        />
                                        <label htmlFor="presenca_outros_riscos" className="label-client-radio">Sim</label>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="modal-cliente-radio">
                                        <input
                                        type="radio"
                                        id="presenca_outros_riscos_nao"
                                        name="presenca_outros_riscos"
                                        value="0"
                                        checked={dadosForm.presenca_outros_riscos === "0"}
                                        onChange={e => setDadosForm({ ...dadosForm, presenca_outros_riscos: e.target.value })}
                                        />
                                        <label htmlFor="presenca_outros_riscos_nao" className="label-client-radio">Não</label>
                                    </div>
                                </div>

                                <div className="modal-form-dados-acidente-espaco"></div>

                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="outros_riscos" style={{ whiteSpace: "nowrap" }} className="label-client-text">
                                        Caso sim, quais? {errosForm.outros_riscos && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="outros_riscos"
                                        name="outros_riscos"
                                        value={dadosForm.outros_riscos}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>USO DE EPI</h3>
                            <div className="modal-hseq-bloco1">
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="epi_presente" style={{ whiteSpace: "nowrap" }} className="label-client-text">
                                        Listar EPI presentes {errosForm.epi_presente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="epi_presente"
                                        name="epi_presente"
                                        value={dadosForm.epi_presente}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="epi_ausente" style={{ whiteSpace: "nowrap" }} className="label-client-text">
                                        Listar EPI Ausentes {errosForm.epi_ausente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="epi_ausente"
                                        name="epi_ausente"
                                        value={dadosForm.epi_ausente}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                                <div className="modal-form-dados-acidente-espaco"></div>
                                <div className="input-group-margem-reduzida">
                                    <label htmlFor="epi_observacoes" style={{ whiteSpace: "nowrap" }} className="label-client-text">
                                        Observações {errosForm.epi_observacoes && <FiAlertTriangle size={12} color="#ff0000"/>}
                                    </label>
                                    <input
                                        className="modal-cliente-input"
                                        type="text"
                                        id="epi_observacoes"
                                        name="epi_observacoes"
                                        value={dadosForm.epi_observacoes}
                                        onChange={e => handleChange(e)}
                                    />
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>CAUSAS DO ACIDENTE</h3> {errosForm.grupo_3 && <FiAlertTriangle size={12} color="#ff0000"/>}
                            <div className="modal-hseq-bloco1">
                                <div className="modal-hseq-bloco1">
                                    <h4 style={{height: "35px", lineHeight: "35px"}}>1. Comportamento / Falha Humana</h4>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="ato_inseguro_trabalhador"
                                                id="ato_inseguro_trabalhador"
                                                checked={dadosForm.ato_inseguro_trabalhador === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, ato_inseguro_trabalhador: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="ato_inseguro_trabalhador" className="label-client-radio">
                                                Ato inseguro do trabalhador
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="desatencao_distracao"
                                                id="desatencao_distracao"
                                                checked={dadosForm.desatencao_distracao === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, desatencao_distracao: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="desatencao_distracao" className="label-client-radio">
                                                Desatenção ou distração
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="pressa"
                                                id="pressa"
                                                checked={dadosForm.pressa === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, pressa: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="pressa" className="label-client-radio">
                                                Pressa ou comportamento apressado
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="excesso_confianca"
                                                id="excesso_confianca"
                                                checked={dadosForm.excesso_confianca === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, excesso_confianca: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="excesso_confianca" className="label-client-radio">
                                                Excesso de confiança
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="falta_treinamento"
                                                id="falta_treinamento"
                                                checked={dadosForm.falta_treinamento === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, falta_treinamento: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="falta_treinamento" className="label-client-radio">
                                                Falta de capacitação ou treinamento
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="uso_inadequado_ferramentas"
                                                id="uso_inadequado_ferramentas"
                                                checked={dadosForm.uso_inadequado_ferramentas === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, uso_inadequado_ferramentas: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="uso_inadequado_ferramentas" className="label-client-radio">
                                                Uso inadequado de ferramentas ou equipamentos
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="improvisacao"
                                                id="improvisacao"
                                                checked={dadosForm.improvisacao === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, improvisacao: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="improvisacao" className="label-client-radio">
                                                Improvisação
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="fadiga"
                                                id="fadiga"
                                                checked={dadosForm.fadiga === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, fadiga: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="fadiga" className="label-client-radio">
                                                Fadiga física ou mental
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="negligencia_procedimentos"
                                                id="negligencia_procedimentos"
                                                checked={dadosForm.negligencia_procedimentos === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, negligencia_procedimentos: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="negligencia_procedimentos" className="label-client-radio">
                                                Negligência ou descumprimento de procedimentos
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-hseq-bloco1">
                                    <h4 style={{height: "35px", lineHeight: "35px"}}>2. Equipamentos / Ferramentas / Engenharia</h4>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="falha_equipamento"
                                                id="falha_equipamento"
                                                checked={dadosForm.falha_equipamento === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, falha_equipamento: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="falha_equipamento" className="label-client-radio">
                                                Falha de equipamento ou ferramenta
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="falta_manutencao_preventiva"
                                                id="falta_manutencao_preventiva"
                                                checked={dadosForm.falta_manutencao_preventiva === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, falta_manutencao_preventiva: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="falta_manutencao_preventiva" className="label-client-radio">
                                                Falta de manutenção preventiva
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="equipamento_defeito_conhecido"
                                                id="equipamento_defeito_conhecido"
                                                checked={dadosForm.equipamento_defeito_conhecido === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, equipamento_defeito_conhecido: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="equipamento_defeito_conhecido" className="label-client-radio">
                                                Equipamento com defeito conhecido
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="equipamento_inadequado"
                                                id="equipamento_inadequado"
                                                checked={dadosForm.equipamento_inadequado === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, equipamento_inadequado: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="equipamento_inadequado" className="label-client-radio">
                                                Utilização de equipamento/ferramenta inadequado para a tarefa
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="ausencia_dispositivo_protecao"
                                                id="ausencia_dispositivo_protecao"
                                                checked={dadosForm.ausencia_dispositivo_protecao === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, ausencia_dispositivo_protecao: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="ausencia_dispositivo_protecao" className="label-client-radio">
                                                Ausência de dispositivos de proteção (ex: proteção de correia, botão de emergência)
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="projeto_inadequado"
                                                id="projeto_inadequado"
                                                checked={dadosForm.projeto_inadequado === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, projeto_inadequado: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="projeto_inadequado" className="label-client-radio">
                                                Projeto inadequado de máquina, processo ou instalação
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-hseq-bloco1">
                                    <h4 style={{height: "35px", lineHeight: "35px"}}>3. Ambiente de Trabalho</h4>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="iluminacao_inadequada"
                                                id="iluminacao_inadequada"
                                                checked={dadosForm.iluminacao_inadequada === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, iluminacao_inadequada: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="iluminacao_inadequada" className="label-client-radio">
                                                Iluminação inadequada
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="ruido_excessivo"
                                                id="ruido_excessivo"
                                                checked={dadosForm.ruido_excessivo === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, ruido_excessivo: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="ruido_excessivo" className="label-client-radio">
                                                Ruído excessivo
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="temperatura_extrema"
                                                id="temperatura_extrema"
                                                checked={dadosForm.temperatura_extrema === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, temperatura_extrema: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="temperatura_extrema" className="label-client-radio">
                                                Temperatura extrema
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="piso_inseguro"
                                                id="piso_inseguro"
                                                checked={dadosForm.piso_inseguro === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, piso_inseguro: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="piso_inseguro" className="label-client-radio">
                                                Piso escorregadio ou irregular
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="obstrucao_rotas"
                                                id="obstrucao_rotas"
                                                checked={dadosForm.obstrucao_rotas === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, obstrucao_rotas: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="obstrucao_rotas" className="label-client-radio">
                                                Obstrução em rotas de fuga ou circulação
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="sinalizacao_inadequada"
                                                id="sinalizacao_inadequada"
                                                checked={dadosForm.sinalizacao_inadequada === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, sinalizacao_inadequada: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="sinalizacao_inadequada" className="label-client-radio">
                                                Sinalização inadequada
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-hseq-bloco1">
                                    <h4 style={{height: "35px", lineHeight: "35px"}}>4. Uso ou Ausência de EPIs</h4>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="nao_uso_epi"
                                                id="nao_uso_epi"
                                                checked={dadosForm.nao_uso_epi === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, nao_uso_epi: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="nao_uso_epi" className="label-client-radio">
                                                Não uso de EPI necessário
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="uso_incorreto_epi"
                                                id="uso_incorreto_epi"
                                                checked={dadosForm.uso_incorreto_epi === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, uso_incorreto_epi: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="uso_incorreto_epi" className="label-client-radio">
                                                Uso incorreto de EPI
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="epi_danificado_ou_ineficaz"
                                                id="epi_danificado_ou_ineficaz"
                                                checked={dadosForm.epi_danificado_ou_ineficaz === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, epi_danificado_ou_ineficaz: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="epi_danificado_ou_ineficaz" className="label-client-radio">
                                                EPI danificado ou ineficaz
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="falta_epi"
                                                id="falta_epi"
                                                checked={dadosForm.falta_epi === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, falta_epi: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="falta_epi" className="label-client-radio">
                                                Falta de fornecimento de EPI adequado
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-hseq-bloco1">
                                    <h4 style={{height: "35px", lineHeight: "35px"}}>5. Processos e Organização</h4>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="intrucao_inadeqada"
                                                id="intrucao_inadeqada"
                                                checked={dadosForm.intrucao_inadeqada === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, intrucao_inadeqada: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="intrucao_inadeqada" className="label-client-radio">
                                                Instruções de trabalho inadequadas ou inexistentes
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="falta_planejamento"
                                                id="falta_planejamento"
                                                checked={dadosForm.falta_planejamento === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, falta_planejamento: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="falta_planejamento" className="label-client-radio">
                                                Falta de planejamento ou análise de risco da tarefa
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="mudanca_tarefa"
                                                id="mudanca_tarefa"
                                                checked={dadosForm.mudanca_tarefa === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, mudanca_tarefa: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="mudanca_tarefa" className="label-client-radio">
                                                Mudança de tarefa sem reavaliação dos riscos
                                            </label>
                                        </div>
                                    </div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="falha_comunicacao"
                                                id="falha_comunicacao"
                                                checked={dadosForm.falha_comunicacao === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, falha_comunicacao: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="falha_comunicacao" className="label-client-radio">
                                                Falha na comunicação entre equipe
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="supervisao_ineficiente"
                                                id="supervisao_ineficiente"
                                                checked={dadosForm.supervisao_ineficiente === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, supervisao_ineficiente: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="supervisao_ineficiente" className="label-client-radio">
                                                Supervisão insuficiente
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="ausencia_procedimento"
                                                id="ausencia_procedimento"
                                                checked={dadosForm.ausencia_procedimento === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, ausencia_procedimento: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="ausencia_procedimento" className="label-client-radio">
                                                Ausência de procedimentos operacionais definidos
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-hseq-bloco1">
                                    <h4 style={{height: "35px", lineHeight: "35px"}}>6. Fatores Externos</h4>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="interferencia_terceiros"
                                                id="interferencia_terceiros"
                                                checked={dadosForm.interferencia_terceiros === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, interferencia_terceiros: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="interferencia_terceiros" className="label-client-radio">
                                                Interferência de terceiros (visitantes, fornecedores, etc.)
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="fatores_climaticos"
                                                id="fatores_climaticos"
                                                checked={dadosForm.fatores_climaticos === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, fatores_climaticos: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="fatores_climaticos" className="label-client-radio">
                                                Fatores climáticos adversos (chuva, vento, calor)
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="evento_externo_nao_previsto"
                                                id="evento_externo_nao_previsto"
                                                checked={dadosForm.evento_externo_nao_previsto === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, evento_externo_nao_previsto: e.target.checked ? '1' : '' })}
                                            />
                                            <label htmlFor="evento_externo_nao_previsto" className="label-client-radio">
                                                Evento externo não previsto (queda de energia, interrupção de rede, etc.)
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-hseq-bloco1">
                                    <h4 style={{height: "35px", lineHeight: "35px"}}>7. Outros</h4>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        <div className="modal-cliente-radio">
                                            <input
                                                type="checkbox"
                                                name="outra_causa_acidente"
                                                id="outra_causa_acidente"
                                                checked={dadosForm.outra_causa_acidente === '1'}
                                                value="1"
                                                onChange={e => setDadosForm({ ...dadosForm, outra_causa_acidente: e.target.checked ? '1' : '0' })}
                                            />
                                            <label htmlFor="outra_causa_acidente" className="label-client-radio">
                                                Outro?
                                            </label>
                                        </div>
                                    </div>
                                    <div className="modal-form-dados-acidente-espaco"></div>
                                    <div className="input-group-margem-reduzida">
                                        {errosForm.outra_causa_acidente === '1' && <>
                                            <label htmlFor="descricao_outra_causa_acidente" style={{ whiteSpace: "nowrap" }} className="label-client-text">
                                                Outro (especificar): {errosForm.descricao_outra_causa_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                            </label>
                                            <input
                                                className="modal-cliente-input"
                                                type="text"
                                                id="descricao_outra_causa_acidente"
                                                name="descricao_outra_causa_acidente"
                                                value={dadosForm.descricao_outra_causa_acidente}
                                                onChange={e => handleChange(e)}
                                            />
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            <br /> <hr /> <br />
                            <h3>AÇÕES CORRETIVAS E PREVENTIVAS</h3>
                            <div className="modal-hseq-bloco1">
                                <label htmlFor="numero_medidas_acidente" className="label-client-text">
                                    Informe o número de medidas a serem tomadas: {errosForm.numero_medidas_acidente && <FiAlertTriangle size={12} color="#ff0000"/>}
                                </label>
                                <div>
                                    <div className="quantidade-medidas-acidente">
                                    <button onClick={(e) => diminuirNumeroMedidasAcidente(e)}><FiMinusCircle size={15}/></button>
                                    <div> {dadosForm.numero_medidas_acidente} </div>
                                    <button onClick={(e) => aumentaNumeroMedidasAcidente(e)}><FiPlusCircle size={15}/></button>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-hseq-bloco1">
                                {medidas.map((medida, index) => (
                                    <div key={index} className="bloco-medida">
                                        <h4>Medida {index + 1}</h4>
                                        <div>Ação/Medida: </div>
                                        <textarea
                                            id={`textarea_acao_medida_${index}`}
                                            name={`textarea_acao_medida_${index}`}
                                            value={medida.acao}
                                            onChange={e => handleChangeMedida(index, 'acao', e.target.value)}
                                            rows="5"
                                            cols="50"
                                        />
                                        <br />
                                        <div>
                                            Tipo:
                                            <div className="bloco-medida-espaco"></div>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={`tipo_${index}`}
                                                    value="Corretiva"
                                                    checked={medida.tipo === 'Corretiva'}
                                                    onChange={e => handleChangeMedida(index, 'tipo', e.target.value)}
                                                /> Corretiva
                                            </label>
                                            <div className="bloco-medida-espaco"></div>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={`tipo_${index}`}
                                                    value="Preventiva"
                                                    checked={medida.tipo === 'Preventiva'}
                                                    onChange={e => handleChangeMedida(index, 'tipo', e.target.value)}
                                                /> Preventiva
                                            </label>
                                        </div>
                                        <br />
                                        <div>Responsável: <input
                                            type="text"
                                            value={medida.responsavel}
                                            onChange={e => handleChangeMedida(index, 'responsavel', e.target.value)}
                                        /></div>
                                        <br />
                                        <div>Prazo de execução: <input
                                            type="date"
                                            placeholder="Prazo"
                                            value={medida.prazo}
                                            onChange={e => handleChangeMedida(index, 'prazo', e.target.value)}
                                        /></div>
                                        <br />
                                        <div>
                                            Status:
                                            <div className="bloco-medida-espaco"></div>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={`status_${index}`}
                                                    value="Pendente"
                                                    checked={medida.status === 'Pendente'}
                                                    onChange={e => handleChangeMedida(index, 'status', e.target.value)}
                                                /> Pendente
                                            </label>
                                            <div className="bloco-medida-espaco"></div>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={`status_${index}`}
                                                    value="Em andamento"
                                                    checked={medida.status === 'Em andamento'}
                                                    onChange={e => handleChangeMedida(index, 'status', e.target.value)}
                                                /> Em andamento
                                            </label>
                                            <div className="bloco-medida-espaco"></div>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={`status_${index}`}
                                                    value="Concluído"
                                                    checked={medida.status === 'Concluído'}
                                                    onChange={e => handleChangeMedida(index, 'status', e.target.value)}
                                                /> Concluído
                                            </label>
                                        </div>
                                    </div>
                                ))}

                            </div>
                            <br /> <hr /> <br />
                            <h3>OBSERVAÇÕES FINAIS / LIÇÕES APRENDIDAS</h3>
                            <div className="modal-hseq-bloco1">
                                <div className="input-group-margem-reduzida">
                                    <textarea
                                        className="modal-cliente-input"
                                        id="observacoes_finais_licoes_aprendidas"
                                        name="observacoes_finais_licoes_aprendidas"
                                        value={dadosForm.observacoes_finais_licoes_aprendidas}
                                        onChange={e => handleChange(e)}
                                        rows="200"
                                        cols="400"
                                    />
                                </div>
                            </div>

                            <div className="modal-cadastrar-novo-usuario-base">
                                <div className="modal-editar-informacoes-comuns-wrapper-botoes">
                                    {permissaoUsuario.verificar(60, token.tipo_usuario)? (<button onClick={(e) => limparFormulario(e)}>Limpar Formulário</button>) : (<></>)}
                                    
                                    {permissaoUsuario.verificar(60, token.tipo_usuario)? (<button onClick={(e) => preencherTeste(e)}>Preencher para teste</button>) : (<></>)}
                                    
                                    <button className="button-cancel" type="button" onClick={() => props.fecharModal()}> Cancelar </button>
                                    
                                    <button className="button-submit-azul" type="button" onClick={(e) => validarAcidente(e)}> Validar </button>
                                    
                                    {props.doneCadastrarAcidente ? (
                                        <>
                                            <button className="button-submit" type="submit" onClick={(e) => cadastrarAcidente(e)}> Salvar </button>
                                            {Object.keys(errosForm).length > 0 &&
                                                <div className='alerta-formulario-acidente'>
                                                    Erros detectados!
                                                    <span> <FiAlertTriangle size={12} color="#ff0000"/> </span>
                                                </div>
                                            }
                                        </>
                                    )  :  ( 
                                        <button className="button-carregando" >
                                            <DynamicLoading height={"40px"} />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}